import React, { Component } from 'react'
import DashboardLock from '../widgets/DashboardLock'
import AboutCompanyCard from './dashboardComponent/settings/AboutCompanyCard'
import CompanyQrCodeCard from './dashboardComponent/settings/CompanyQrCodeCard'
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner';

class MinimalCompanyProfile extends Component {
    
    render() {
        const { companyData, ProductOrder,themeColors } = this.props;
        let boughtOrderId = 'boughtSubscription' in companyData ? companyData.boughtSubscription.orderId : null;
        const subscriptionBoughtActive = boughtOrderId ? companyData.boughtSubscription.applied : false
        if (subscriptionBoughtActive) {
            if (ProductOrder && companyData) {
                // console.log(ProductOrder)
                const { tagCount, tagLimit, companyMembersLimit } = ProductOrder;
                const { totalActiveCompanyMembers } = companyData;
                const tagLimitReached = tagCount > tagLimit ? true : false;
                // console.log(totalActiveCompanyMembers, companyMembersLimit)
                const companyMemberLimitReached = companyMembersLimit === "-1" ? false : totalActiveCompanyMembers > companyMembersLimit ? true : false;
                // console.log(companyMemberLimitReached)
                // console.log(tagCount,tagLimit);
                if (tagLimitReached) {
                    return (
                        <React.Fragment>
                            <DashboardLock />
                        </React.Fragment>
                    );
                }
                if (companyMemberLimitReached) {
                    return (
                        <div className="container-fluid py-3">
                            <div className="card-deck mb-2 px-2">
                                {/* <AboutCompanyCard />
                                <CompanyQrCodeCard />
                                <ManageMemberCard /> */}
                            </div>
                        </div>
                    );
                }
                else {
                    return (
                        <div className="container-fluid py-3">
                            <div className="card-deck mb-2 px-2">
                                <AboutCompanyCard />
                                <CompanyQrCodeCard />
                                <div className="card p-2 " style={{ borderRadius: '15px', border: 'none', backgroundColor: 'transparent' }} ></div>
        
                            </div>
                        </div>
                    )
                }
            }
            else {
                return (
                    <div className="container-fluid">
                        <div className="" >
                            <div className="card p-3 pt-5">
                                <Loader
                                    type="TailSpin"
                                    color={themeColors.themeColor}
                                    height={50}
                                    width={50}
                                />
                                {/* <br></br>
                                <p style={textStyle}>Loading your company...</p>
                                <br></br> */}
                            </div>
                        </div>
                    </div>
                )
            }
            
        }
        else {
            return (
                <React.Fragment>
                    <DashboardLock />
                </React.Fragment>
            )
        }
    }
}
const mapStateToProps = (state) => {
    return {
        companyData: state.firestore.data.Company,
        ProductOrder: state.firestore.data.ProductOrder,
        themeColors: state.theme,
    }
}

export default connect(mapStateToProps)(MinimalCompanyProfile)